import { LegacyCard } from "@shopify/polaris";
import React from "react";
import { FilterStatus } from "./FilterStatus";
import { ShipmentLogStatus, SortOrder } from "src/graphql/codegen_graphql";
import { FilterOrder } from "./FilterOrder";
import { FilterSearch } from "./FilterSearch";

interface Props {
  status: ShipmentLogStatus[];
  setStatus: (value: ShipmentLogStatus[]) => void;
  orderBy: SortOrder;
  setOrderBy: (value: SortOrder) => void;
  search: string;
  setSearch: (value: string) => void;
}

export function ShipmentFilter(props: Props) {
  return (
    <LegacyCard.Section>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "space-between" }}>
        <div>
          <FilterStatus status={props.status} setStatus={props.setStatus} />
        </div>
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <div className="pl-3">
            <FilterSearch search={props.search} setSearch={props.setSearch} />
          </div>
          <div className="pl-3">
            <FilterOrder orderBy={props.orderBy} setOrderBy={props.setOrderBy} />
          </div>
        </div>
      </div>
    </LegacyCard.Section>
  );
}
